import React from "react";
import { format } from "date-fns";
import Icon from "./icon";

import * as styles from "../styles/components/post-item.module.css";

const PostItem = (props) => {

  const {
    _key,
    media,
    publishedOn,
    link,
    file,
    title
  } = props;

  return (
    <div className={styles.root} key={_key} data-sal="slide-up" data-sal-duration="800" data-sal-easing="ease-out">
      <div className={styles.meta}>
        <div>{media ? media : "Press Release"}</div>
        {publishedOn && <div>{format(new Date(publishedOn).setDate(new Date(publishedOn).getDate() + 1), "MM / dd / yyyy")}</div>}
      </div>
      {(link || (file && file.asset)) && (
        <div className={styles.title}>
          <a className="normalpp" href={link ? link : file.asset.url + "/" + file.asset.originalFilename} target="_blank" rel="noreferrer">{title}<Icon symbol="external-lg" /></a>
        </div>
      )}
    </div>
  );
}

export default PostItem;
